import { render, staticRenderFns } from "./Shutters.vue?vue&type=template&id=2150357e"
import script from "./Shutters.vue?vue&type=script&lang=ts"
export * from "./Shutters.vue?vue&type=script&lang=ts"
import style0 from "./Shutters.vue?vue&type=style&index=0&id=2150357e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports